import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import BACKEND_URL from '../../../api';
import { useCountry } from '../../../context/CountryContext';
import Sidebar from './Sidebar'
import ChartOne from './ChartOne';
import ChartTwo from './ChartTwo';
import ChartThree from './ChartThree';
import ChartFour from './ChartFour';
import ChartFive from './ChartFive';
import ChartSix from './ChartSix';
import "../../../Analysis.css";

const Dashboard = () => {
    const { currency } = useCountry();
    const userid = sessionStorage.getItem('userid')
    const thisYear = new Date().getFullYear();

    const [isOpen, setIsOpen] = useState(false);
    const [selectedYear, setSelectedYear] = useState(0);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [totalShipments, setTotalShipments] = useState(0);
    const [totalWeight, setTotalWeight] = useState(0);
    const [lastTotalRevenue, setLastTotalRevenue] = useState(0);
    const [lastTotalWeight, setLastTotalWeight] = useState(0);
    const [lastTotalShipments, setLastTotalShipments] = useState(0);

    useEffect(() => {
        axios.post(`${BACKEND_URL}/getTotalData`, {
            thisYear: selectedYear,
            userid: userid
        }, {})
            .then((res) => {
                console.log("getTotalData------------", res.data)
                setTotalRevenue(res.data.totalRevenue);
                setTotalWeight(res.data.totalWeight);
                setLastTotalRevenue(res.data.lastTotalRevenue);
                setLastTotalWeight(res.data.lastTotalWeight);
                setTotalShipments(res.data.totalShipments);
                setLastTotalShipments(res.data.lastTotalShipments);
            })
            .catch((err) => console.log(err))
    }, [selectedYear])

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="my_parcels">
            <Helmet>
                <title>Shypv | Analytics</title>
            </Helmet>
            <div className="myparctab" style={{ padding: "0" }} >

                <div className="container-fluid" style={{ padding: "0" }}>
                    <div className="row1">

                        <Sidebar isOpen={isOpen} />

                        {/* /#admin-sidebar */}
                        <div id="admin-main-control" className="col-md-9 p-x-3 p-y-1" style={{ overflow: "auto", backgroundColor: "#f1f5f9" }}>
                            <div style={{ boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}>
                                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                                    <div className="container-fluid" style={{ justifyContent: "space-between" }}>
                                        <button className="navbar-toggler" type="button" onClick={toggleSidebar}>
                                            {
                                                isOpen ? (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-left"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
                                                        />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="32"
                                                        height="32"
                                                        className="bi bi-arrow-bar-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
                                                        />
                                                    </svg>
                                                )
                                            }
                                        </button>
                                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="offset-1 collapse navbar-collapse" id="navbarNav">
                                            <ul className="navbar-nav">
                                                <>
                                                    <li className="nav-item">
                                                        <NavLink activeclassname="active" exact to="/">HOME</NavLink>
                                                        {/* <Link className="nav-link active"  aria-current="page" exact  to="/">HOME  </Link> */}
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/track">TRACK</NavLink>
                                                        {/* <Link className="nav-link" exact  to="/track">TRACK</Link> */}
                                                    </li>

                                                    {/* <li className="nav-item">
                                                            <NavLink exact to="/smart-send">SMART SEND</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/your-business">YOUR BUSINESS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/help">HELP</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/become-a-partner">PARTNERS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/parcels-on-demand">HOW IT WORKS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="https://www.tymexlogistics.com/" target="_blank">LOGISTICS</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/client-zone">CLIENT ZONE</NavLink>
                                                        </li> */}
                                                </>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>

                            <div style={{ margin: "5px", padding: "5px" }}>
                                <div className="col-md-12 col-sm-12 col-xs-12" style={{ marginTop: "2%", borderRadius: "6px" }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '10px 0 0 10px' }}>
                                        <label className="label--reg">Year:</label>
                                        <select className="form-control" style={{ width: "150px", cursor: 'pointer' }} value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                                            <option value="0">2021-{thisYear}</option>
                                            {
                                                Array.from({ length: thisYear - 2021 + 1 }, (_, index) => 2021 + index).map((year) => {
                                                    return (
                                                        <option value={year} key={year}>{year}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>

                                    <div className='cardBox'>
                                        <div className='col-xl-4 col-lg-12'>
                                            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                                                <div className="card">
                                                    <h4 className="revenue-amount">{totalRevenue} {currency}</h4>
                                                    <p className="revenue-label">Total Billing</p>
                                                    {
                                                        selectedYear !== 0 && (
                                                            <p style={{ fontSize: "0.875em", color: "#6B7280" }}>
                                                                {lastTotalRevenue > 0 ? (
                                                                    <>
                                                                        <span className="percentage" style={{ color: "red", fontWeight: "bold" }}>
                                                                            {((totalRevenue / lastTotalRevenue) * 100).toFixed(1)}%
                                                                        </span>
                                                                        = was {lastTotalRevenue} {currency} last year
                                                                    </>
                                                                ) : (
                                                                    <span>No data available for last year.</span>
                                                                )}
                                                            </p>
                                                        )
                                                    }
                                                </div>
                                                <div className="card">
                                                    <h4 className="revenue-amount">{totalWeight} KG</h4>
                                                    <p className="revenue-label">Total Weight</p>
                                                    {
                                                        selectedYear !== 0 && (
                                                            <p style={{ fontSize: "0.875em", color: "#6B7280" }}>
                                                                {lastTotalWeight > 0 ? (
                                                                    <>
                                                                        <span className="percentage" style={{ color: "red", fontWeight: "bold" }}>
                                                                            {((totalWeight / lastTotalWeight) * 100).toFixed(1)}%
                                                                        </span>
                                                                        = was {lastTotalWeight} KG last year
                                                                    </>
                                                                ) : (
                                                                    <span>No data available for last year.</span>
                                                                )}
                                                            </p>
                                                        )
                                                    }
                                                </div>
                                                <div className="card">
                                                    <h4 className="revenue-amount">{totalShipments}</h4>
                                                    <p className="revenue-label">Total Shipments</p>
                                                    {
                                                        selectedYear !== 0 && (
                                                            <p style={{ fontSize: "0.75em", color: "#6B7280" }}>
                                                                {lastTotalRevenue > 0 ? (
                                                                    <>
                                                                        <span className="percentage" style={{ color: "red", fontWeight: "bold" }}>
                                                                            {((totalShipments / lastTotalShipments) * 100).toFixed(1)}%
                                                                        </span>
                                                                        = was {lastTotalShipments} last year
                                                                    </>
                                                                ) : (
                                                                    <span>No data available for last year.</span>
                                                                )}
                                                            </p>
                                                        )
                                                    }
                                                </div>
                                                <ChartTwo year={selectedYear} />
                                                <ChartThree year={selectedYear} />
                                            </div>
                                        </div>
                                        <div className='col-xl-8 col-lg-12'>
                                            <ChartOne year={selectedYear} />
                                            <ChartSix year={selectedYear} />
                                            <ChartFour year={selectedYear} />
                                            <ChartFive year={selectedYear} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard
